import { ContactLayout } from "@features/layout/contact";

export const ContactPage = () => {
  return <ContactLayout />;
};
